const SHOW_SNACK = 'SHOW_SNACK'
const HIDE_SNACK = 'HIDE_SNACK'

const initialState = {
  show: false,
  message: ''
}

const state = { ...initialState }

const mutations = {
  [SHOW_SNACK]: function (state, payload) {
    state.show = true
    state.message = payload
  },
  [HIDE_SNACK]: function (state) {
    state.show = false
  }
}

const actions = {
  showSnack ({ commit }, payload) {
    commit(SHOW_SNACK, payload)
  },
  hideSnack ({ commit }) {
    commit(HIDE_SNACK)
  }
}

const getters = {
  getMessage (state) {
    return state.message
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
